var map = {
	"./en/Common.json": "0a2d",
	"./en/Cookie.json": "bb3b",
	"./en/Inclusive.json": "c53f",
	"./en/PageNotFound.json": "3d8b",
	"./en/Validations.json": "3f19",
	"./ru/Common.json": "7dfa",
	"./ru/Cookie.json": "2c7b",
	"./ru/Inclusive.json": "48bf",
	"./ru/PageNotFound.json": "ca56",
	"./ru/Validations.json": "64a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";